export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReELOTBwdi1SS1NKLUhhBYFBAb1PDQG9UQkCvVMCBL1WBBG9W0EVgYG9bYIdAAEAAQABAAEAGQAfAAEAAQAGAFMAAQABAAEAAQAZACAAAQABAAYAYQGDlQG+AnESh58AvgQAwQkAvgcAvgUAwQoBwQ0BwREAvgsBwRMAvgkAvgwAvhIBwRcAvg4BwRsAvg8AwR0AvhFhBoe9AMEeAADBIQAAwSQAAMEmAADBJTgCwQQ=", "base64")


//////////////////
// WEBPACK FOOTER
// ./src/components/vue-pdf/src/buffer-loader.js!./node_modules/pdfjs-dist/cmaps/90pv-RKSJ-V.bcmap
// module id = tIag
// module chunks = 0